/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  FcmTokensControllerSubscribeToFcmMutationRequest,
  FcmTokensControllerSubscribeToFcmMutationResponse,
  FcmTokensControllerSubscribeToFcm401,
} from '../../types/FcmTokensControllerSubscribeToFcm.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { fcmTokensSubscribeToFcm } from '../../methods/fcmTokensSubscribeToFcm.ts';
import { useMutation } from '@tanstack/react-query';

export const fcmTokensSubscribeToFcmMutationKey = () => [{ url: '/api/notifications/subscribe-fcm' }] as const;

export type FcmTokensSubscribeToFcmMutationKey = ReturnType<typeof fcmTokensSubscribeToFcmMutationKey>;

/**
 * {@link /api/notifications/subscribe-fcm}
 */
export function useFcmTokensSubscribeToFcm<TContext>(
  options: {
    mutation?: UseMutationOptions<
      FcmTokensControllerSubscribeToFcmMutationResponse,
      ResponseErrorConfig<FcmTokensControllerSubscribeToFcm401>,
      { data: FcmTokensControllerSubscribeToFcmMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<FcmTokensControllerSubscribeToFcmMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? fcmTokensSubscribeToFcmMutationKey();

  return useMutation<
    FcmTokensControllerSubscribeToFcmMutationResponse,
    ResponseErrorConfig<FcmTokensControllerSubscribeToFcm401>,
    { data: FcmTokensControllerSubscribeToFcmMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return fcmTokensSubscribeToFcm(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
